<template>
  <v-btn
    v-bind="$props"
    v-on="$listeners"
    icon
    plain
    @click="$emit('click:delete-item', $attrs.item)"
    >
    <slot>
    <v-icon color="blue">{{ $icons.delete }}</v-icon>
    </slot>
  </v-btn>
</template>

<script>
import { VBtn } from 'vuetify/lib'

export default {
  name: 'DeleteItemAction',
  extends: VBtn,
}
</script>

